import type { FilterModel } from './filterModel'

function buildMinMaxValues(key: string, filter: FilterModel) {
  const values = {}

  const minKey = `min_${key}`
  const maxKey = `max_${key}`

  if (!filter) return values

  // Equal To
  if (filter.comparison === 'eq'){
    // @ts-expect-error TS7053
    values[minKey] = filter.value
    // @ts-expect-error TS7053
    values[maxKey] = filter.value
  }

  // Greater Than
  if (filter.comparison === 'gt'){
    // @ts-expect-error TS7053
    values[minKey] = filter.value
  }

  // Less Than
  if (filter.comparison === 'lt'){
    // @ts-expect-error TS7053
    values[maxKey] = filter.value
  }

  // Between
  if (filter.comparison === 'bt'){
    // @ts-expect-error TS7053
    values[minKey] = filter.value
    // @ts-expect-error TS7053
    values[maxKey] = filter.valueMax
  }

  return values
}

export default buildMinMaxValues
